import React, { createContext, useState, useMemo, useEffect } from "react";
import { getSubdirectory } from "../utils/GetSubdirectory";

const ThemeContext = createContext({
  mode: 'dark',
  setMode: () => { }
});

const ThemeContextProvider = ({ children }) => {
  const subdirectory = getSubdirectory();

  const [mode, setMode] = useState(() => {
    // Retrieve theme mode from localStorage or default to 'light'
    return localStorage.getItem(`${subdirectory}-themeMode`) || 'light';
  });

  useEffect(() => {
    // Save theme mode to localStorage whenever it changes
    localStorage.setItem(`${subdirectory}-themeMode`, mode);
  }, [mode, subdirectory]);

  const value = useMemo(() => ({ mode, setMode }), [mode]);

  return <ThemeContext.Provider value={value}>
    {children}
  </ThemeContext.Provider>
}

export { ThemeContext, ThemeContextProvider }